import { supabase } from '@/lib/supabase';

export async function getBudgetStatus(projectId) {
  const { data, error } = await supabase.from('v_project_budget_status').select('*').eq('project_id', projectId).maybeSingle();
  if (error) throw error;
  return data;
}

export async function getProjectBudget(projectId) {
  const { data, error } = await supabase
    .from('project_cost_codes')
    .select('*, cost_codes(code, description, category)')
    .eq('project_id', projectId).eq('is_current', true);
  if (error) throw error;
  return (data || []).sort((a, b) => (a.cost_codes?.code || '').localeCompare(b.cost_codes?.code || ''));
}

export async function syncProjectBudget(projectId) {
  const { data, error } = await supabase.rpc('sync_project_budget', { _project_id: projectId });
  if (error) throw error;
  return data;
}
